import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { API_URL } from "../utilities/url";
import storage from "../services/storage";
import CryptoJS from "crypto-js";
import authService from "../services/auth.service";

export const AssistantContext = createContext();

export const AssistantProvider = ({ children }) => {
  const workspaces = storage.get("wrs")
    ? JSON.parse(
        CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
          CryptoJS.enc.Utf8
        )
      )
    : null;
  const [assistantList, setAssistantList] = useState([]);
  const [assistantSessionList, setAssistantSessionList] = useState([]);
  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [workspace, setWorkspace] = useState(workspaces);
  const [selectedSessionAssistant, setSelectedSessionAssistant] =
    useState(null);
  const [activeAssistant, setActiveAssistant] = useState(null);
  const [defaultAssistant, setDefaultAssistant] = useState(null);
  const [loadingAs, setLoadingAs] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      getAssistant();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const getAssistant = async () => {
    axios
      .post(
        API_URL + "get-personal-assistant-list",
        {
          idt_workspace: workspace
            ? workspace.idt_user_workspace
            : workspaces.idt_user_workspace,
          page: 1,
          limit: 500,
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          setAssistantSessionList(
            response.data.data.data ? response.data.data.data : []
          );
          setDefaultAssistant(
            response.data.data.data
              .filter((item) => item.default !== null)
              .map((item) => item.idt_user_assistant)[0]
          );
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const loadAssistant = async (id) => {
    try {
      setLoadingAs(true);
      const response = await axios.post(
        API_URL + "get-personal-assistant-list",
        { idt_workspace: id, page: 1, limit: 500 },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      );
      const data = await response.data.data;
      setAssistantList(data ? data : []);
      setAssistantSessionList(data ? data.data : []);
      setLoadingAs(false);
    } catch (error) {
      if (error.response.data.message) {
        authService.logout();
      } else {
        setLoadingAs(false);
      }
    }
  };

  return (
    <AssistantContext.Provider
      value={{
        assistantList,
        setAssistantList,
        assistantSessionList,
        setAssistantSessionList,
        selectedAssistant,
        setSelectedAssistant,
        selectedSessionAssistant,
        setSelectedSessionAssistant,
        firstLoad,
        setFirstLoad,
        activeAssistant,
        setActiveAssistant,
        defaultAssistant,
        setDefaultAssistant,
        loadingAs,
        setLoadingAs,
        loadAssistant,
      }}
    >
      {children}
    </AssistantContext.Provider>
  );
};
